// 存储-服务
export default {

  /**
   * 保存数据
   *
   * @param key 键
   * @param value 值
   */
  setItem(key,value) {
    localStorage.setItem(key,value);
  },

  /**
   * 获取数据
   *
   * @param key 键
   */
  getItem(key) {
    return localStorage.getItem(key);
  },

  /**
   * 删除数据
   *
   * @param key 键
   */
  removeItem(key) {
    localStorage.removeItem(key);
  },

  /**
   * 清空数据
   */
  clear() {
    localStorage.clear();
  }
}



// WEBPACK FOOTER //
// ./src/assets/plugin/prototypes/modules/storage.js